module.exports = __webpack_public_path__ + "static/img/recharge.cb37535.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/recharge.png
// module id = Z1s3
// module chunks = 1